import { Button } from 'react-bootstrap';
import React from 'react';

const FooterSidebar = () => {
    return ( 
        <div className='footer-sidebar d-inline-block w-100'>
            <div className='footer-sidebar-btn d-flex'>
                <Button variant='none' className='w-75 f-action text-light'>اعمال فیلتر</Button>
                <Button variant='light' className='w-25 f-del'>حذف</Button>
            </div>
        </div>
     );
}
 
export default FooterSidebar;